import React, { useState, useEffect, useRef } from 'react';
import { GOLD, BLACK } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';
import GoldBtn from './ui/GoldBtn';

const slides = [
  { bg: IMGS.hero[0], tag: 'GOWJEE CATERERS', h: 'Modern Catering\nDone Right', sub: 'Bespoke menus, farm-fresh ingredients, and seamless service for weddings, corporate events, and private celebrations' },
  { bg: IMGS.hero[1], tag: 'BESPOKE & FLEXIBLE', h: 'Your Vision.\nOur Kitchen.', sub: 'From plated dinners to live stations and grazing tables — we tailor every detail to your style and dietary needs' },
  { bg: IMGS.hero[2], tag: 'ELEVATED EXPERIENCE', h: 'Events That\nLeave an Impression', sub: 'Chef-driven cuisine, premium presentation, and professional staffing so you can enjoy your own party' },
];

const Hero: React.FC = () => {
  const [curr, setCurr] = useState(0);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const go = (dir: number) => setCurr(c => (c + dir + slides.length) % slides.length);

  useEffect(() => {
    timer.current = setInterval(() => go(1), 5500);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, []);

  const s = slides[curr];
  return (
    <section id="home" style={{ position:'relative', height:'100vh', overflow:'hidden' }}>
      {slides.map((sl, i) => (
        <div key={i} style={{ position:'absolute', inset:0, backgroundImage:`url(${sl.bg})`, backgroundSize:'cover', backgroundPosition:'center', transition:'opacity 1.1s ease', opacity: i===curr ? 1 : 0 }}>
          <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.58)' }}/>
        </div>
      ))}
      <div style={{ position:'relative', zIndex:2, height:'100%', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', padding:'0 20px' }}>
        <SecLabel text={s.tag}/>
        <h1 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(38px,6vw,84px)', fontWeight:300, color:'#fff', lineHeight:1.18, marginTop:10, whiteSpace:'pre-line', textShadow:'0 2px 30px rgba(0,0,0,0.4)' }}>{s.h}</h1>
        <p style={{ color:'rgba(255,255,255,0.8)', fontFamily:'Montserrat', fontSize:13, letterSpacing:1, marginTop:18, maxWidth:560 }}>{s.sub}</p>
        <div style={{ display:'flex', gap:14, marginTop:36 }}>
          <GoldBtn href="#contact">Book Now</GoldBtn>
          <GoldBtn href="#menu" outline={false}>View Menu</GoldBtn>
        </div>
      </div>
      <div style={{ position:'absolute', bottom:26, left:'50%', transform:'translateX(-50%)', display:'flex', gap:8, zIndex:3 }}>
        {slides.map((_,i) => (
          <button key={i} onClick={() => setCurr(i)} style={{ width:i===curr?26:7, height:7, borderRadius:4, background:i===curr?GOLD:'rgba(196,152,50,0.32)', border:'none', cursor:'pointer', transition:'all 0.4s' }}/>
        ))}
      </div>
      {([['❮',-1,'left'],['❯',1,'right']] as const).map(([ch,dir,side]) => (
        <button key={side} onClick={() => go(dir as number)} style={{ position:'absolute', top:'50%', transform:'translateY(-50%)', [side]:22, background:'rgba(0,0,0,0.36)', border:`1px solid rgba(196,152,50,0.33)`, color:GOLD, fontSize:15, width:42, height:42, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', zIndex:3, transition:'all 0.3s' } as React.CSSProperties}
          onMouseOver={e => { (e.currentTarget as HTMLElement).style.background = GOLD; (e.currentTarget as HTMLElement).style.color = BLACK; }}
          onMouseOut={e => { (e.currentTarget as HTMLElement).style.background = 'rgba(0,0,0,0.36)'; (e.currentTarget as HTMLElement).style.color = GOLD; }}>{ch}</button>
      ))}
    </section>
  );
};

export default Hero;